import type { CarbonApi, CarbonZone } from '@/ports/carbon-api'

/**
 * HttpCarbonApi : adapter GET /api/v1/carbon/zones (control-plane).
 *
 * Le catalogue de zones est statique côté backend (embarqué, valable y compris
 * air-gap). En cas d'échec (401/5xx/réseau ou body invalide) on retourne une
 * liste vide : le sélecteur retombe alors sur sa seule option « zone par
 * défaut » — le formulaire ProviderKey reste utilisable.
 */
export class HttpCarbonApi implements CarbonApi {
    private readonly baseURL: string

    constructor(baseURL = '') {
        this.baseURL = baseURL.replace(/\/+$/, '')
    }

    async zones(): Promise<CarbonZone[]> {
        let resp: Response
        try {
            resp = await fetch(this.baseURL + '/api/v1/carbon/zones', {
                method: 'GET',
                credentials: 'include',
            })
        } catch {
            return []
        }
        if (!resp.ok) {
            return []
        }
        let body: unknown
        try {
            body = await resp.json()
        } catch {
            return []
        }
        const raw = (body as { zones?: unknown })?.zones
        if (!Array.isArray(raw)) {
            return []
        }
        return raw
            .map((entry) => {
                const zone = entry as { code?: unknown; label?: unknown }
                return {
                    code: typeof zone.code === 'string' ? zone.code : '',
                    label: typeof zone.label === 'string' ? zone.label : '',
                }
            })
            .filter((zone) => zone.code !== '')
    }
}
